import { creditCheckServices } from '@services';
import { selectLoggedInUserState } from '@store';
import { getCleanedUrlParams, showError } from '@utils';
import { QUERY_KEYS } from 'constants/queryKeys';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useAssignees } from 'hooks/common';
import {
  getCreditCheckQueryParams,
  getCreditCheckTableCardColumns,
  getCreditCheckPayload,
  handleCreditCheckTableData,
} from './utils';

export const CREDIT_CHECK_TABLE_PAGE_SIZE = 200;

export const useCreditCheckTableOperations = () => {
  const loggedInUser = useSelector(selectLoggedInUserState);
  const { assignees, isFetching: isAssigneesFetching } = useAssignees();

  const { query, isReady } = useRouter();
  const {
    page = 1,
    pageSize = CREDIT_CHECK_TABLE_PAGE_SIZE,
    origin,
    contractType,
    dateFrom,
    dateTo,
    stage,
    query: searchQuery,
  } = query;
  const params = getCleanedUrlParams({
    page,
    pageSize: pageSize || CREDIT_CHECK_TABLE_PAGE_SIZE,
    order: 'desc',
    orderBy: 'createdAt',
    query: searchQuery,
  });
  const cleanedParams = getCreditCheckQueryParams(params);

  const filtersPayload = getCleanedUrlParams({
    origin,
    contractType,
    stage,
    dateFrom,
    dateTo,
  });
  const cleanedPayload = getCreditCheckPayload(filtersPayload);

  const creditCheckTableResponse = useQuery(
    [QUERY_KEYS.GET_CREDIT_CHECK_TABLE_KEY, cleanedParams, cleanedPayload],
    () => {
      return creditCheckServices.getCreditCheckDataFilter({
        urlParams: cleanedParams,
        payload: cleanedPayload,
      });
    },
    { enabled: isReady }
  );

  useEffect(() => {
    if (creditCheckTableResponse?.error) {
      showError(creditCheckTableResponse?.error);
    }
  }, [creditCheckTableResponse?.error]);

  const creditCheckTable = handleCreditCheckTableData(
    creditCheckTableResponse?.data?.data || [],
    assignees
  );
  const columns = getCreditCheckTableCardColumns(creditCheckTable || []);

  return {
    page,
    loggedInUser,
    total: creditCheckTableResponse?.data?.meta?.total,
    pageSize: parseInt(pageSize, 10) || CREDIT_CHECK_TABLE_PAGE_SIZE,
    loading: creditCheckTableResponse.isFetching || isAssigneesFetching,
    data: creditCheckTable,
    columns,
    assignees,
    getCreditCheckTable: creditCheckTableResponse.refetch,
  };
};
